import React from 'react'
import { Card, CardContent, CardMedia, Typography, Link, Box } from '@mui/material'
import { venueCapacity } from '../../utils/venueParser'
import ReadMoreText from '../common/ReadMoreText'

const CustomVenueBox = ({ venueData, highlightedSection, venueRef }) => {
    // Safely get the first image URL
    console.log("CustomVenueBox Venue data:", venueData);
    const imageUrl = venueData?.coverImage || venueData?.VenueImages?.[0]?.url || 'default-image-url.jpg'
    // Format capacity for display
    const formatCapacity = (capacity) => {
        if (!capacity) return 'Not specified'
        return `Seated: ${capacity.seated || 'N/A'} | Standing: ${capacity.standing || 'N/A'}`
    }

    const capacity = venueCapacity(venueData);

    return (
        <Card ref={venueRef} sx={{ width: '100%' }}>
            <Box display="flex" flexDirection="row" alignItems="stretch" width="100%">
                <CardMedia
                    component="img"
                    sx={{ width: '25%', objectFit: 'cover', borderRadius: 2, alignSelf: 'stretch', minWidth: 80 }}
                    image={imageUrl}
                    alt={venueData?.title || 'Venue Image'}
                />
                <CardContent sx={{ flex: 1, p: 2, '&:last-child': { pb: 2 } }}>
                    <Typography variant="h6" component="h2" gutterBottom>
                        {venueData?.title || 'Venue Name Not Available'}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                        {venueData?.city}, {venueData?.state} |
                        Capacity: {formatCapacity(capacity)}
                    </Typography>
                    <ReadMoreText
                        text={venueData?.desc || 'No description available'}
                        maxLength={150}
                        variant="body1"
                        color="text.primary"
                        sx={{ mt: 2 }}
                        readMoreText="Read more"
                        showLessText="Show less"
                    />
                    <Link
                        href={`/venue/${venueData?.id}`}
                        underline="hover"
                        sx={{
                            fontSize: '1rem',
                            transition: 'all 0.3s ease-in-out',
                            ...(highlightedSection === 'venue' && {
                                backgroundColor: 'rgba(25, 118, 210, 0.1)',
                                padding: '4px',
                                borderRadius: '4px',
                            }),
                        }}
                    >
                        Visit Venue Page
                    </Link>
                </CardContent>
            </Box>
        </Card>
    )
}

export default CustomVenueBox 